import { styled } from '@mui/material/styles';
import { SearchInput } from '@components/SearchInput';
import { Switch } from '@components/Switch';
import { useTranslation } from '@hooks';

const Toggles = styled('div')({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0 16px',
    marginBottom: '16px',
});

const GoogleLocationsFilters = ({ filter }) => {
    const { t } = useTranslation();

    if (!filter.hasLocations) return null;

    return (
        <>
            <SearchInput value={filter.query} onChange={filter.setQuery} label={t('GoogleLocationsList.searchLabel')} />
            {(filter.hasConnected || filter.hasUnverified) && (
                <Toggles>
                    {filter.hasConnected && (
                        <Switch
                            checked={filter.hideConnected}
                            handleChange={e => filter.setHideConnected(e.target.checked)}
                            label={t('GoogleLocationsList.hideConnected')}
                        />
                    )}
                    {filter.hasUnverified && (
                        <Switch
                            checked={filter.hideUnverified}
                            handleChange={e => filter.setHideUnverified(e.target.checked)}
                            label={t('GoogleLocationsList.hideUnverified')}
                        />
                    )}
                </Toggles>
            )}
        </>
    );
};

export default GoogleLocationsFilters;
